module.exports = __webpack_public_path__ + "static/assets/1c6a0d9aadd524d63a3fac9113076858.gif";